const getDateFormat = (option?: 'date' | 'time' | 'dateTime') => {
  if (option === 'time') {
    return 'HH:mm'
  }
  if (option === 'dateTime') {
    return 'dd.MM.yyyy HH:mm'
  }
  return 'dd.MM.yyyy'
}

export default getDateFormat
